import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import LAvatar from '@/global-components/LAvatar.vue'
import LButton from '@/components/core/Button.vue'
import DeleteModal from '@/components/core/DeleteModal.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import DropdownMenuItem from '@/components/core/DropdownMenuItem.vue'
import { useContext } from '@/composables/context'
import { useRemoveUser } from '@/composables/attendee'
import { useSelectedTrip } from '@/composables/trip'
import { authModule, tripModule } from '@/store'
import { User } from '@/types/user'
import { logEvent } from '@/utils/utility-manager'

interface AttendeesListItemProps {
  attendee: User
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttendeesListItem',
  props: {
    attendee: null
  },
  emits: ["showPicture"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'showPicture', pictureUrl: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  attendee: User
};





const trip = useSelectedTrip()
const router = useRouter()

const { mutateAsync: removeUser } = useRemoveUser(trip.value._id)

const showConfirmDialog = ref(false)

const isMe = computed(() => props.attendee._id === authModule.user.id)
const isLastAttendee = computed(() => trip.value.attendees.length === 1)

const { i18n } = useContext()

const confirmLabel = computed(() => {
  if (isMe.value) {
    if (isLastAttendee.value) {
      return i18n.t('deleteTrip').toString()
    } else {
      return i18n.t('leaveTrip').toString()
    }
  } else {
    return i18n.t('removeAttendee').toString()
  }
})

const confirmTitle = computed(() => {
  if (isMe.value) {
    if (isLastAttendee.value) {
      return i18n.t('deleteTripPrompt').toString()
    } else {
      return i18n.t('leaveTripPrompt').toString()
    }
  } else {
    return i18n
      .t('removeAttendeePrompt', { name: props.attendee.firstName })
      .toString()
  }
})

const confirmDescription = computed(() => {
  if (isMe.value) {
    if (isLastAttendee.value) {
      return i18n.t('deleteTripLastAttendeeDescription').toString()
    } else {
      return i18n.t('leaveTripDescription').toString()
    }
  } else {
    return i18n
      .t('removeAttendeeDescription', { name: props.attendee.firstName })
      .toString()
  }
})

function handleClickRemove() {
  showConfirmDialog.value = true
}

async function handleRemoveUser() {
  await removeUser(props.attendee._id)
  logEvent('trip_share_attendee_removed')

  if (isMe.value) {
    await router.replace({ path: '/' })
  } else {
    await tripModule.fetch(trip.value._id)
  }
}

function handleShowPicture(pictureUrl: string) {
  logEvent('trip_share_attendee_picture_viewed')
  emit('showPicture', pictureUrl)
}

return { __sfc: true,props, emit, trip, router, removeUser, showConfirmDialog, isMe, isLastAttendee, i18n, confirmLabel, confirmTitle, confirmDescription, handleClickRemove, handleRemoveUser, handleShowPicture, LAvatar, LButton, DeleteModal, DropdownMenu, DropdownMenuItem }
}

})